import styled from "styled-components";
import { COLORS, responsive } from "../../styles/constants.style";

export const TimelineActivityWrapper = styled.div`
  .activity-scroll-container {
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    display: block;
  }

  .activity-scroll-container > * {
    min-width: 900px;
  }
  & > div:not(.pagination-wrapper) {
    padding-left: 16px;

    ${responsive.MOBILE`
      padding-left: 8px;
    `}
  }

  .pagination-wrapper {
    border-top: 1px solid ${COLORS.cirrus_black4};

    .go-to-controls {
      display: flex;
      align-items: baseline;
      ${responsive.MOBILE`
        display: flex;
        justify-content: flex-end;
        align-items: baseline;
        gap: 12px;
      `}
    }
  }

  .no-result {
    padding: 24px 0px;

    .MuiTypography-root {
      color: ${COLORS.cirrus_black10};
    }
  }
`;
